import { Text } from '@consta/uikit/Text'
import type { MarkerSetupType } from '@core/core/types'
import type { FC } from 'react'

import { useSettingsPredictor } from '../markersHelpers'
import { AttributesTable } from './AttributesTable'
import { FileHeaderTable } from './FileHeaderTable'
import { PropertiesPanel } from './PropertiesPanel'
import css from './Setup.css'
import type { SetupProps } from './types'

export const Setup: FC<SetupProps> = ({ file, settings, parsedData, updateFileConfig }) => {
  const update = (diff: Partial<MarkerSetupType>) => {
    if (file.fileId) {
      updateFileConfig(file.fileId, { ...settings, ...diff })
    }
  }

  useSettingsPredictor(parsedData.fileHeader?.lines, update)

  return (
    <div data-testid="import-markers-setup" className={css.setupContainer}>
      <div className={css.halfWidth}>
        <PropertiesPanel settings={settings} update={update} />
        <AttributesTable
          settings={settings}
          contentRow={parsedData.fileHeader?.firstLineCells ?? []}
          update={update}
        />
      </div>
      <div className={css.importTextWrapper}>
        <Text size="s" view="secondary" className={css.importText}>
          Файл импорта (первые 50 строк)
        </Text>
        <div className={css.codeFrame}>
          <FileHeaderTable textualHeader={parsedData.fileHeader} />
        </div>
      </div>
    </div>
  )
}
